import React from 'react'
import { makeStyles } from '@mui/styles'

import lang from '@/lang'
import { FailedDocument } from './types'

const fixErrorsLang = lang.documentExport.fixErrors

interface FixErrorsIntroProps {
  documents: FailedDocument[]
}

const useStyles = makeStyles(() => ({
  hint: {
    fontWeight: 600,
  },
  count: {
    paddingBottom: 10,
    marginTop: 20,
    fontWeight: 600,
  },
}))

const FixErrorsIntro: React.FC<FixErrorsIntroProps> = ({ documents }) => {
  const classes = useStyles()

  const countsByCategory = documents.reduce<Record<string, number>>((result, { category }) => {
    result[category] = (result[category] ?? 0) + 1
    return result
  }, {})

  return (
    <div>
      <p dangerouslySetInnerHTML={{ __html: fixErrorsLang.introText }}></p>
      <p className={classes.hint}>{fixErrorsLang.introHint}</p>
      <div className={classes.count} dangerouslySetInnerHTML={{ __html: fixErrorsLang.failedDocumentsCount(documents.length) }}></div>
      <ul>
        {Object.entries(countsByCategory).map(([category, count]) => (
          <li key={category}><b>{fixErrorsLang.categories[category] ?? category}:</b> {count}</li>
        ))}
      </ul>
    </div>
  )
}

export default FixErrorsIntro
